import { Box } from "@mui/system";
import Image from "next/image";
import { Brand } from "@/core/types/types";
import { useContext } from "react";
import { ConfigContext } from "@/core/contexts/ConfigContext";
import useCustomStyles from "@/core/hooks/useCustomStyles/useCustomStyles";
import { ExtendedTheme } from "../Theme";

const styles = (theme: ExtendedTheme) => ({
  root: {
    display: "flex",
    height: "10px",
  },
  wrapper: {
    marginRight: theme.spacing(1),
    width: "100%",
    borderRadius: theme.spacing(0.5),
    background: theme.palette.background.default,
  },
  progress: {
    height: "10px",
    transition: "width .1s ease-in-out",
    background: theme.palette.progress?.complete || theme.palette.primary.main,
    borderRadius: theme.spacing(0.5),
  },
});

interface ProgressBarProps {
  progressPercentage?: string;
}

const ProgressBar = ({ progressPercentage }: ProgressBarProps) => {
  const classes: any = useCustomStyles(styles);
  const initialisationConfig = useContext(ConfigContext);
  const showPlane: boolean = initialisationConfig.brandId === Brand.FLIGHTRIGHT;
  classes.progress.styles += ";width: " + progressPercentage + "%";

  if (!progressPercentage) return null;

  return (
    <Box sx={classes?.root}>
      <Box sx={classes?.wrapper}>
        <Box sx={{ ...classes.progress }} />
      </Box>
      {showPlane && (
        <Image
          width="20"
          height="10"
          src="images/icons/plane.svg"
          alt="plane"
        />
      )}
    </Box>
  );
};

export default ProgressBar;
